import React from 'react'
import styled, { withTheme } from 'styled-components'

import { CtaButton } from '../../../../../src/ui/buttons/Button.jsx'
import { ColoredIcon } from '../../../../../src/ui/icons/Icon.jsx'
import { handleKeyboardSelect } from '../../../../utils/keyboardUtils.js'

const ButtonWrapper = styled.div`
  display: flex;
  margin: 12px 0;

  ${ColoredIcon} {
    margin-right: 8px;
  }
`

const CtaButtonStyled = styled(CtaButton)`
  border-radius: ${({ theme }) => theme.standardRadius};

  &:focus-visible {
    outline: 1px solid blue;
    outline-offset: 2px;
  }
`

const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
`

/**
 * Renders a "Reserve Parking" CTA for parking POIs by grabbing the first link directly.
 *
 * Props:
 *  - poi.links: array where the first element contains the booking URL
 *  - poi.category: must start with "parking" to show this button
 *  - T: translation function
 */
const ReserveParkingButton = withTheme(({ theme, poi, T }) => {
  const bookingLink = poi.links?.[0]?.url
  const { category } = poi
  const isParking = typeof category === 'string' && category.startsWith('parking')
  if (!isParking || !bookingLink) return null

  const handleClick = (e) => {
    e.stopPropagation()
    window.open(bookingLink, '_blank')
  }

  return (
    <ButtonWrapper data-cy="ReserveParkingButton">
      <CtaButtonStyled
        onClick={handleClick}
        onKeyDown={handleKeyboardSelect(handleClick, { stopPropagation: true })}
        backgroundColor={theme.colors.primaryButton}
        hoverBackgroundColor={theme.colors.primaryButtonHover}
        fontColor={theme.colors.primaryButtonText}
        tabIndex={0}
        aria-label={T('poiView:Reserve Parking')}
      >
        <IconWrapper>
          <ColoredIcon
            id="calendar"
            width={24}
            height={24}
            fillColor={theme.colors.primaryButtonText}
          />
        </IconWrapper>
        {T('poiView:Reserve Parking')}
      </CtaButtonStyled>
    </ButtonWrapper>
  )
})

export default ReserveParkingButton
